import { App } from "@src/App";
import ReactDOM from "react-dom/client";
import { loadRecaptcha } from "@endya-conformite/ui-kit";

loadRecaptcha();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />
);
